import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SectionHead from './SectionHead';
import Reveal from './Reveal';
import { color } from '../../theme/tokens';
import { BP, LANDING_FONT, LC, MAXW, MOTION, PAD_X, r } from './landingTokens';

const CARDS = [
  { tag: 'Exploring solutions?', title: 'Conditions', desc: 'See which supplements the evidence supports for a given condition.', cta: 'Browse →', to: '/conditions' },
  { tag: 'Told to take something?', title: 'Supplements', desc: 'Examine any supplement — how it works, side effects, and the research.', cta: 'Explore →', to: '/supplements' },
  { tag: 'Want the source?', title: 'Research', desc: 'Read the studies behind any recommendation — methods, results, and who funded them.', cta: 'Read →', to: '/supplements', feature: true },
  { tag: 'Ready to buy?', title: 'Market', desc: 'Pick a third-party-tested product — never sponsored, never an ad.', cta: 'Shop →', to: '/products' },
];

export default function ExploreGrid() {
  const navigate = useNavigate();
  return (
    <Box component="section" id="library" sx={{ background: LC.surfaceAlt, borderTop: `${r(1)} solid ${LC.border}`, borderBottom: `${r(1)} solid ${LC.border}`, display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '100%', maxWidth: MAXW, px: PAD_X, py: 'clamp(3.5rem, 8vw, 6rem)' }}>
        <Reveal repeat>
          <SectionHead
            eyebrow="Go deeper"
            title="One place to explore, evaluate, and buy."
            lead="Start anywhere — the evidence standard is the same."
            maxWidth={r(620)}
            leadMaxWidth="50ch"
          />
        </Reveal>

        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', [BP.phoneLg]: { gridTemplateColumns: 'repeat(2, 1fr)' }, [BP.desktop]: { gridTemplateColumns: 'repeat(4, 1fr)' }, gap: r(16), mt: 'clamp(1.875rem, 4vw, 2.75rem)' }}>
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * MOTION.stagger} repeat sx={{ display: 'flex' }}>
            <Box
              component="button"
              onClick={() => navigate(c.to)}
              sx={{
                width: '100%',
                textAlign: 'left',
                cursor: 'pointer',
                border: `${r(1)} solid ${c.feature ? LC.evergreen : LC.border}`,
                borderRadius: r(18),
                p: r(24),
                background: c.feature ? LC.surfaceTint : LC.surface,
                display: 'flex',
                flexDirection: 'column',
                transition: 'border-color 180ms ease, background 180ms ease, transform 180ms ease, box-shadow 180ms ease',
                '&:hover': {
                  borderColor: LC.evergreen,
                  transform: 'translateY(-0.1875rem)',
                  boxShadow: '0 0.75rem 1.75rem -0.75rem rgba(12,31,23,.28)',
                  ...(c.feature ? { background: color.mint } : {}),
                },
                '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } },
              }}
            >
              <Box component="span" sx={{ fontFamily: LANDING_FONT, fontSize: r(12.5), fontWeight: 600, color: LC.accent }}>{c.tag}</Box>
              <Box component="span" sx={{ fontFamily: LANDING_FONT, fontWeight: 800, fontSize: r(20), letterSpacing: '-0.01em', mt: r(4), color: LC.ink }}>{c.title}</Box>
              <Box component="p" sx={{ fontFamily: LANDING_FONT, fontSize: r(13.5), color: LC.inkSoft, lineHeight: 1.55, mt: r(8), mb: 0 }}>{c.desc}</Box>
              <Box component="span" sx={{ fontFamily: LANDING_FONT, fontWeight: 700, fontSize: r(13.5), color: LC.accent, mt: 'auto', pt: r(16) }}>{c.cta}</Box>
            </Box>
            </Reveal>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
